<template>
  <el-dialog
    title="Adicionar endereço a rota"
    :append-to-body="true"
    center
    :visible.sync="dialog"
    width="80%"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-position="right"
      label-width="160px"
    >
      <el-form-item
        v-if="branchs && branchs.length > 0"
        label="Selecionar Filial"
      >
        <el-switch v-model="showBranchs"></el-switch>
      </el-form-item>

      <el-form-item>
        <el-radio v-model="ruleForm.type" @change="changeType" label="customer"
          >Cliente</el-radio
        >
        <el-radio v-model="ruleForm.type" @change="changeType" label="collect"
          >Ponto de coleta</el-radio
        >
        <el-radio v-model="ruleForm.type" @change="changeType" label="branch"
          >Agencia</el-radio
        >
      </el-form-item>
      <el-form-item :label="$t('cliente')" v-if="ruleForm.type === 'customer'">
        <CustomerList
          v-model="ruleForm.customer"
          ref="customerList"
          :customerType="0"
          :multiple="false"
          @selected="updated"
        />
      </el-form-item>
      <el-form-item :label="'Filial'" v-if="showBranchs">
        <BrachsList
          v-model="selectedBranch"
          ref="branchsList"
          @selected="selecteBranch"
          :branchs="branchs"
        />
      </el-form-item>

      <el-form-item label="Endereços" v-if="ruleForm.type === 'customer'">
        <CustomerAddressList
          v-model="ruleForm.address"
          :customer="getAddressParamn"
          @selected="selected"
        />
      </el-form-item>
      <el-row :gutter="5">
        <el-col :xs="20" :sm="16" :md="12" :lg="8" :xl="6">
          <el-form-item
            :label="$t('cep')"
            prop="cep"
            v-if="ruleForm.type !== 'customer'"
          >
            <el-input
              maxlength="9"
              v-model="ruleForm.cep"
              v-mask="'#####-###'"
              @blur="zipcode()"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="18" :md="16" :lg="12" :xl="10">
          <el-form-item
            :label="$t('endereco')"
            prop="address"
            v-if="ruleForm.type !== 'customer'"
          >
            <el-input v-model="ruleForm.address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18" :md="16" :lg="6" :xl="5">
          <el-form-item
            :label="$t('numero')"
            prop="number"
            v-if="ruleForm.type !== 'customer'"
          >
            <el-input
              v-model="ruleForm.number"
              @blur="location"
              maxlength="5"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if="infoData.distance">
        <el-tag type="info"
          >{{ infoData.distance }} - {{ infoData.duration }}</el-tag
        >
      </el-form-item>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="18" :md="16" :lg="10" :xl="10">
          <el-form-item
            :label="$t('bairro')"
            prop="neighborhood"
            v-if="ruleForm.type !== 'customer'"
          >
            <el-input v-model="ruleForm.neighborhood" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18" :md="16" :lg="8" :xl="8">
          <el-form-item
            :label="$t('cidade')"
            prop="city"
            v-if="ruleForm.type !== 'customer'"
          >
            <el-input v-model="ruleForm.city" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18" :md="16" :lg="6" :xl="3">
          <el-form-item
            :label="$t('estado')"
            prop="state"
            v-if="ruleForm.type !== 'customer'"
          >
            <el-input v-model="ruleForm.state" maxlength="2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="18" :md="12" :lg="12" :xl="10">
          <el-form-item label="Nome" v-if="ruleForm.type !== 'customer'">
            <el-input v-model="ruleForm.name" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="18" :md="12" :lg="12" :xl="10">
          <el-form-item label="E-mail">
            <el-input v-model="ruleForm.mail" maxlength="180"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        label="Descrição detalhada"
        v-if="ruleForm.type !== 'customer'"
      >
        <el-input v-model="ruleForm.description" maxlength=""></el-input>
      </el-form-item>
      <el-form-item
        label="Horário chegada"
        prop="description"
        class="is-required"
      >
        <el-time-select
          v-model="ruleForm.time"
          :picker-options="{
            start: start,
            step: '00:10',
            end: '20:00',
          }"
          placeholder="Select time"
        >
        </el-time-select>
      </el-form-item>
      <el-form-item label="Tempo espera" prop="wait" class="is-required">
        <el-time-select
          v-model="ruleForm.wait"
          :picker-options="{
            start: '00:00',
            step: '00:10',
            end: '02:00',
          }"
          placeholder="Select time"
        >
        </el-time-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" autofocus @click="generateRoute">
        Adicionar
      </el-button>
      <el-button @click="dialog = false">Cancelar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import BrachsList from "./BrachsList.vue";
import { GeocoderService } from "@/services/umov/geocoder.services";
import { gmapApi } from "vue2-google-maps";
import { i18n } from "@/plugin/i18n";
import ZipMixins from "@/xpost/mixins/zipcode";
import CustomerAddressList from "../../../register/customer/CustomerAddressList.vue";
import { CustomerService } from "@/services/customers/customers.services";
import { DateTime } from "luxon";

export default {
  name: "TravelRouteCustomerAdd",
  components: {
    CustomerList,
    CustomerAddressList,
    BrachsList,
  },
  mixins: [ZipMixins],
  computed: {
    google: gmapApi,
  },
  data() {
    return {
      start: "06:00",
      dialog: false,
      showBranchs: false,
      position: null,
      markers: [],
      waypoints: [],
      mapData: null,
      infoData: {
        lat: 0,
        lng: 0,
        distance: "",
        duration: "",
      },
      geocoder: null,
      ruleForm: {
        type: "customer",
        customer: "",
        mail: '',
        branch: "",
        address: "",
        time: "09:00",
        wait: "00:10",
        cep: "",
        name: "",
        description: "",
        city: "",
        neighborhood: "",
        state: "",
        number: "",
      },
      branchs: [],
      selectedBranch: null,
      getAddressParamn: null,
    };
  },
  methods: {
    location() {
      const vm = this;
      if (vm.ruleForm.cep && vm.ruleForm.number) {
        const addressData = {
          ...vm.ruleForm,
          name:
            vm.ruleForm.type == "customer"
              ? "Cliente"
              : vm.ruleForm.type == "collect"
              ? "Ponto de Coleta"
              : "Agência",
          zipcode: vm.ruleForm.cep,
        };
        vm.selected(addressData);
      }
    },
    changeType() {
      this.infoData.distance = "";
      this.infoData.duration = "";
    },

    open(position) {
      this.customer = "";
      this.ruleForm.address = "";
      this.ruleForm.customer = "";
      this.selectedBranch = "";
      this.infoData.distance = "";
      this.infoData.duration = "";
      if (this.$refs.customerList) this.$refs.customerList.clear();
      if (this.$refs.branchsList) this.$refs.branchsList.clear();
      this.position = position;
      this.dialog = true;
    },

    getBranchs() {
      const loading = this.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      CustomerService.getBranchsByCustomer(this.ruleForm.customer)
        .then((response) => {
          this.branchs = response;
        })
        .catch((error) => {
          this.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    updated(data) {
      const vm = this;
      vm.ruleForm.customer = data;
      this.getAddressParamn = data;
      if (vm.ruleForm.customer) this.getBranchs();
    },

    selecteBranch(data) {
      this.selectedBranch = data;
      this.getAddressParamn = data;
    },

    selected(addressData) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      console.log('geocoder', vm.position)
      GeocoderService.geocoder({
        ...addressData,
        customer: vm.ruleForm.customer,
      })
        .then((data) => {
          console.log('geocoder data', data)
          if (!data) {
            return this.$message({
              type: "error",
              duration: 5000,
              message: `Erro ao buscar informações do endereço.`,
            });
          }
          const { lat, lng } = data.geometry;
          vm.mapData = {
            customer: vm.ruleForm.customer,
            formData: { ...vm.ruleForm },
            address: {
              ...data,
              lat,
              lng,
            },
          };
          console.log('vm.position', vm.position)
          if (vm.position) {
            GeocoderService.directions({ 
              origin: `${vm.position.customerData.address.geometry.lat},${vm.position.customerData.address.geometry.lng}`,
              destination: `${data.geometry.lat},${data.geometry.lng}`,
            })
              .then((response) => {
                vm.infoData.distance = response.distance.text;
                vm.infoData.duration = response.duration.text;
              })
              .catch((error) => {
                this.$notify.error({
                  title: i18n.tc("erro"),
                  message: error,
                });
              })
            .finally(() => loading.close());
          }
        })
        .catch((error) => {
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => loading.close());
    },
    time(start, duration) {
      start = start.length === 4 ? "0" + start : start;
      duration = +duration + 300;
      const date = DateTime.fromISO(`2023-09-01T${start}`);
      const min = date.plus({ seconds: +duration });
      const dateObject = date.toObject();
      const minObject = min.toObject();
      const seconds = {
        start: +dateObject.hour * 3600 + +dateObject.minute + 60,
        duration: +minObject.hour * 3600 + +minObject.minute + 60,
      };
      const time =
        +minObject.minute < 30
          ? `${+minObject.hour}:30`
          : `${+minObject.hour + 1}:00`;
      this.start = time;
      this.ruleForm.time = time;
    },
    
    generateRoute() {
      const vm = this;
      if (!this.mapData) {
        return this.$message({
          type: "error",
          duration: 5000,
          message: `Erro ao buscar informações do endereço.`,
        });
      }
      this.mapData.formData.time = vm.ruleForm.time;
      this.mapData.formData.wait = vm.ruleForm.wait;
      vm.$emit("customer", vm.mapData);
      vm.dialog = false;
    },
  },
};
</script>
